
const Analytics = ({ width = 18, height = 18 }) => (
	<svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M2.125 1.5V10.875C2.125 11.9105 2.96447 12.75 4 12.75H5.875M2.125 1.5H0.875M2.125 1.5H15.875M15.875 1.5H17.125M15.875 1.5V10.875C15.875 11.9105 15.0355 12.75 14 12.75H12.125M5.875 12.75H12.125M5.875 12.75L5.04167 15.25M12.125 12.75L12.9583 15.25M12.9583 15.25L13.375 16.5M12.9583 15.25H5.04167M5.04167 15.25L4.625 16.5M6.5 8.375V9.625M9 6.5V9.625M11.5 4.625V9.625" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>

);
export default Analytics;
  